"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvidersFiltersType = void 0;
var ProvidersFiltersType;
(function (ProvidersFiltersType) {
    ProvidersFiltersType["NoFilter"] = "all";
    ProvidersFiltersType["Top"] = "top";
    ProvidersFiltersType["FreePreview"] = "freePreview";
})(ProvidersFiltersType = exports.ProvidersFiltersType || (exports.ProvidersFiltersType = {}));
